import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PriceCollection } from '@api-ui-app/src/app/ngrx/e-commerce-product-wizard.reducer';
import { currencyRound } from '@gelato-api-ui/core/currency/currency-round';
import { SubscriptionDiscount } from '@api-ui-app/src/app/shared/subscription-discounts/types/subscription-discounts';
import { calculateShippingCost } from '@api-ui-app/src/app/shared/subscription-discounts/utils/calculate-shipping-cost';
import { CurrencyRateService } from '@gelato-api-ui/core/currency-rate/services/currency-rate.service';

@Injectable({
  providedIn: 'root',
})
export class ECommerceProductWizardConvertPricesService {
  constructor(private readonly currencyRateService: CurrencyRateService) {}

  convertShippingPricesBasedOnSubscription(
    shippingDiscount: SubscriptionDiscount,
    productCosts: PriceCollection,
    shippingCosts: PriceCollection,
    selectedCurrency: string,
  ): PriceCollection {
    if (!shippingDiscount) {
      return shippingCosts;
    }

    return Object.entries(shippingCosts).reduce(
      (acc: PriceCollection, [variantKey, shippingPrice]): PriceCollection => ({
        ...acc,
        [variantKey]: calculateShippingCost(
          productCosts[variantKey],
          shippingPrice,
          shippingDiscount,
          selectedCurrency,
        ),
      }),
      {},
    );
  }

  convertPriceCollection(
    prices: PriceCollection,
    sourceCurrency: string,
    destinationCurrency: string,
  ): Observable<PriceCollection> {
    if (sourceCurrency === destinationCurrency) {
      return of(prices);
    }

    return this.currencyRateService.get(sourceCurrency, destinationCurrency).pipe(
      map(currencyRate =>
        Object.keys(prices).reduce(
          (acc: PriceCollection, productVariantKey: string): PriceCollection => ({
            ...acc,
            [productVariantKey]: currencyRound(prices[productVariantKey] * currencyRate, destinationCurrency),
          }),
          {},
        ),
      ),
    );
  }
}
